<syslink-grid
    #gridComponent
    [gridName]="storageKey"
    [canView]="canView"
    [canSearch]="canSearch"
    [canRefresh]="canRefresh"
    [canAdd]="canAdd"
    [canSort]="canSort"
    [canUpdate]="canUpdate"
    [canDelete]="canDelete"
    [canFilter]="canFilter"
    [canExport]="canExport"
    [canDblClck]="canDblClck"
    [store]="thirdsService.store"
    [archivedStore]="thirdsService.archivedStore"
    [restoreService]="thirdsService"
    [columns]="columns"
    [expand]="expand"
    (add)="add.emit()"
    [storageKey]="storageKey"
    (doubleClick)="rowDoubleClicked.emit($event)"
></syslink-grid>

